import React, { useState } from "react";
import NewHeader from "../helper/NewHeader";

function LanguageListThree() {
  return (
    <>
     <NewHeader/>
      <main role="main" className="contentarea">        
        <section className="second pb-4">
          <div className="container">
            <div className="listTitle">
              <h2>Searched Keyword: example Text</h2>
            </div>
            <div className="bg-white borderRadi">
                <div className="d-flex justify-content-between editBtn">
                <select name="" id="">
                  <option value="0">English</option>
                  <option value="0">Hindi</option>
                  <option value="0">Tamil</option>
                </select>
                               
            </div>
            <textarea name="text" id="" className="w-100 mt-2 borderLeft" rows="2" placeholder="meaning of the text"></textarea>
            </div>
            <div className="bg-white borderRadi">               
            <textarea name="text" id="" className="w-100 mt-2 borderLess" rows="8" placeholder="Please enter the correct Word ..."></textarea>
            <div className="text-end">
            <button type="button" className="submitbtn">Submit</button>
            </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default LanguageListThree;
